import { render, staticRenderFns } from "./currencymod.vue?vue&type=template&id=13db5e2c&"
import script from "./currencymod.vue?vue&type=script&lang=js&"
export * from "./currencymod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13db5e2c')) {
      api.createRecord('13db5e2c', component.options)
    } else {
      api.reload('13db5e2c', component.options)
    }
    module.hot.accept("./currencymod.vue?vue&type=template&id=13db5e2c&", function () {
      api.rerender('13db5e2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23LixZY8t6TPM/JS/comp/currencymod.vue"
export default component.exports